import { render, staticRenderFns } from "./invoiceFooter.vue?vue&type=template&id=08b37ee8&"
import script from "./invoiceFooter.vue?vue&type=script&lang=js&"
export * from "./invoiceFooter.vue?vue&type=script&lang=js&"
import style0 from "./invoiceFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports